export const isTestEnv = () => process.env.NODE_ENV === 'test';
